'use strict';

import { Dimensions } from 'react-native';
import { IP } from './ip';
import CommonBridge from '../common/CommonBridge';

const DeviceModel = CommonBridge.DeviceModel;

// iPhoneX
const X_MIN_HEIGHT = 812;

// screen
const SCREEN_HEIGHT = Dimensions.get('window').height;

export default class System {
  /**
   * 获取本地图片资源URL
   * @param filename
   * @returns {{uri: string}}
   */
  static getImage(filename, dir) {
    const path = `${dir || (CommonBridge.isMishop() ? 'mishop' : 'youpin')}/${filename}`;
    if (CommonBridge.isWeb()) {
      // console.log('bundle path:', bundle);
      const bundle = CommonBridge.BundlePath;
      // console.log('bundle path:', bundle);
      const img = `${bundle}/res/images/${path}`;
      return () => ({
        uri: img,
      });
    } else {
      if (__DEV__) {
        const img = `http://${IP}:8081/res/images/${path}`;
        return () => {
          return { uri: img };
        };
      } else {
        return () => {
          let bundle = '';
          // if (fromComBundle) {
          //   bundle = CommonBridge.getComInfo().bundlePath || '';
          // } else {
          bundle = CommonBridge.getBuzInfo().bundlePath || '';
          // }
          const img = `file://${bundle}/res/images/${path}`;
          return { uri: img };
        };
      }
    }
  }

  /**
   * 纯JS方式依据屏幕判断iPhone X
   * https://www.theiphonewiki.com/wiki/Models
   * device model name list： https://gist.github.com/adamawolf/3048717
   * @returns {boolean}
   */
  static isIPhoneX() {
    if (CommonBridge.isIOS()) {
      const iphoneXList = [
        'iPhone10,3',
        'iPhone10,6',
        'iPhone11,2',
        'iPhone11,4',
        'iPhone11,6',
        'iPhone11,8',
        'iPhone12,1',
        'iPhone12,3',
        'iPhone12,5',
        'iPhone13,1',
        'iPhone13,2',
        'iPhone13,3',
        'iPhone13,4',
        'iPhone14,4',
        'iPhone14,5',
        'iPhone14,2',
        'iPhone14,3',
        'iPhone14,4',
        'iPhone14,5',
        'iPhone14,6',
        'iPhone14,7',
        'iPhone14,8',
        'iPhone15,2',
        'iPhone15,3',
        'iPhone15,4',
        'iPhone15,5',
        'iPhone16,1',
        'iPhone16,2',
        'iPhone17,1', // iPhone 16 Pro
        'iPhone17,2', // iPhone 16 Pro Max
        'iPhone17,3', // iPhone 16
        'iPhone17,4', // iPhone 16 Plus
      ];
      return iphoneXList.indexOf(DeviceModel) > -1 || (DeviceModel === 'x86_64' && SCREEN_HEIGHT >= X_MIN_HEIGHT);
    }
    return false;
  }

  /**
     -     * 是否嵌入M站（适用于小程序、快应用， 头条小程序）
     -     * @returns {*|boolean}
     -     */
  static isEmbeddedWebview() {
    return (
      CommonBridge.isWeb() &&
      (CommonBridge.isMiuinewapp() || CommonBridge.isWxminiprogram() || CommonBridge.isToutiaominiProgram())
    );
  }
}
